import type React from 'react';

import { cn } from '../../utils';

function Skeleton({
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn(
                'h-full animate-pulse rounded-md bg-muted',
                className,
            )}
            {...props}
        />
    );
}

export { Skeleton };
